import ApiService from '../../../common/ApiCalls'
import { removeAllItemsInSessionStorage } from '../../../services/util/sessionStorageManager'
import { fetchLoginTheme } from '../../../common/dynamicCustomizationService'

export const onLogout = async () => {
  removeAllItemsInSessionStorage()

  const mapCentralization = JSON.parse(
    window.localStorage.getItem('mapCentralization')
  )

  const dontShowInstruction = JSON.parse(
    window.localStorage.getItem('dontShowInstruction')
  )

  let isFirstTimeOnHeatmaps = window.localStorage.getItem('isFirstTimeOnHeatmaps')
  isFirstTimeOnHeatmaps = isFirstTimeOnHeatmaps === 'undefined'
    ? undefined
    : JSON.parse(isFirstTimeOnHeatmaps)

  const application_state = {
    activeUrL: `${window.location.pathname}`,
    activeTab: `${window.location.pathname}`,
    searchedString: '',
    mapBounds: '',
    zoom: mapCentralization?.location_zoom || 5,
    dontShowInstruction: dontShowInstruction || false,
    ...(isFirstTimeOnHeatmaps !== null &&
          isFirstTimeOnHeatmaps !== undefined &&
            { isFirstTimeOnHeatmaps: isFirstTimeOnHeatmaps })
  }

  try {
    await ApiService().logout({ application_state })
    window.localStorage.clear()
    await fetchLoginTheme()
  } catch (error) {
    //Code to handle error comes here
  } finally {
    window.location.replace('login')
  }
}
